import type {ISbStoryData} from "@storyblok/js";
import type {AsyncData} from "nuxt/app";

import {useI18n} from "vue-i18n";
import {useStoryblokStoriesList} from "./use-storyblok-stories-list";

type AsyncOptions = Parameters<typeof useStoryblokStoriesList>[2];

export function useStoryblokOutlets(
	asyncOptions?: AsyncOptions,
): AsyncData<ISbStoryData[], unknown> {
	const {t} = useI18n({
		useScope: "global",
	});

	return useStoryblokStoriesList(
		"storyblok-outlets",
		{
			sort_by: "name:asc",
			starts_with: `${t("storyblok.outlets")}/`,
			is_startpage: false,
			per_page: 60,
		},
		asyncOptions,
	);
}
